import http from "../api/axios-auth-php";
import axios from "../api/axios-auth";

class DashboardService {
    getDashboardStats(data) {
      return http.get("dashboard", { params: data});
    }
    getClientsPointsHistory(data) {
      return http.get("dashboard/clientsPointHistory", { params: data});
    }
    getBreakageTransactionHistory(data) {
      return http.get("dashboard/breakageTransactionHistory", { params: data});
    }
    downloadSaasFeesFile() {
      return http.get("sass-fees/export");
    }
    uploadSassFeesData(data) {
      return http.post("sass-fees/import", data,  {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        });
    }
    addBonusPointData(data) {
      return axios.post("/dv-adm/add-bonus-points", data,  {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        });
    }
    
    fetchShippingDetail(data) {
      return http.get("bestbuy/order/tracking", { params: data});
    }

    // NPS Survey
    getNpsSurveyHistory(data) {
      return http.get("nps/survey/history", { params: data});
    }
    exportNPSHistory() {
      return http.get("nps/survey/export");
    }

    // Sales Tax
    getSalesTaxList(data) {
      return http.get("sales-tax/list", { params: data});
    }
    exportSalesTax(data) {
      return http.get("sales-tax/export", { params: data});
    }
    
    pointMetrics(data) {
      return axios.post("/dv-adm/point-metrics", data);
    }
    lastLoginReport(data) {
      return axios.post("/dv-adm/last-login-report", data);
    }
    revenueMetrics(data) {
      return axios.post("/dv-adm/revenue-metrics", data);
    }
    profitMetrics(data) {
      return axios.post("/dv-adm/profit-metrics", data);
    }
    getAllClients(data) {
      return axios.get("/dv-adm/get-clients", { params: data });
    }
    getOverallMetrics(data) {
      return axios.post("/dv-adm/overall-metrics", data);
    }

    configureClientAccountStatment(data) {
      return axios.post("/dv-adm/set-bal-reminder-schedule", data);
    }

    exportProducts(data) {
      return http.post("products/export",  data);
    }
    downloadProductImportBlankTemplate() {
      return http.post("products/download/template");
    }
    importProduct(data) {
      return http.post("products/import", data,  {
          headers: {
              'Content-Type': 'multipart/form-data'
          }
        });
  }
  }
  
  export default new DashboardService();